import React, { useState } from 'react';
import {
  Card,
  CardContent,
  TextField,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Divider,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

interface FAQ {
  question: string;
  answer: string;
}

interface FAQListProps {
  faqs: FAQ[];
}

const FAQList: React.FC<FAQListProps> = ({ faqs }) => {
  const [search, setSearch] = useState('');
  const [expanded, setExpanded] = useState<number | null>(null);

  const filteredFaqs = faqs.filter(faq =>
    faq.question.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <TextField
          label="Search FAQs"
          variant="outlined"
          fullWidth
          value={search}
          onChange={e => setSearch(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Typography variant="h6" sx={{ mb: 1 }}>Frequently Asked Questions</Typography>
        <List>
          {filteredFaqs.length === 0 && (
            <ListItem>
              <ListItemText primary="No Questions Found" />
            </ListItem>
          )}
          {filteredFaqs.map((faq, idx) => (
            <React.Fragment key={faq.question}>
              <ListItem
                secondaryAction={
                  <IconButton edge="end" onClick={() => setExpanded(expanded === idx ? null : idx)}>
                    {expanded === idx ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                }
                button
                onClick={() => setExpanded(expanded === idx ? null : idx)}
              >
                <ListItemText primary={faq.question} />
              </ListItem>
              <Collapse in={expanded === idx} timeout="auto" unmountOnExit>
                <Box sx={{ pl: 4, pr: 2, pb: 2 }}>
                  <Typography variant="body2" color="text.secondary">{faq.answer}</Typography>
                </Box>
              </Collapse>
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default FAQList; 